import React, { PureComponent } from 'react';
import { LogoutOutlined, MenuOutlined } from '@ant-design/icons';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import { DatasetDto, DatasetType } from 'app/model/CORE';
import logoUrl from 'static-assets/logo_100px.png';

import { Flex } from '../../common/Flex';
import { PopoverMenu } from '../../common/PopoverMenu';
import { ModalHandler } from '../../panels/ModalHandler';
import AppContext from '../../../common/context/AppContext';

// Takes the dataset as a prop to force Re-render on dataset change
export class Banner extends PureComponent<{ dataset: DatasetDto }> {
    render() {
        return (
            <Flex className="banner-panel" direction="horizontal">
                <Flex direction="horizontal" size="auto" style={{ gap: '0.5em', height: '100%', alignItems: 'center' }}>
                    <img src={logoUrl} alt="Logo" style={{ height: '2em', margin: 'auto' }} />
                    <Flex direction="vertical" style={{ gap: '0.25em' }}>
                        {/*<span className="department">NM </span>*/}
                        <span className="product">NMUI 4D </span>
                        <span className="dataset">
                            {this.props.dataset.type === DatasetType.FORECAST ? 'PRETACT' : 'TACT'}
                        </span>
                    </Flex>
                </Flex>
                <BannerMenu />
            </Flex>
        );
    }
}

class BannerMenu extends PureComponent {
    handleMenuItemClick = (key: string) => {
        // TODO: This is temporary code to be able to download static data captured in recording mode.
        // new URLSearchParams(window.location.search).get('record-data') === '1'
        for (const [localStorageKey, value] of Object.entries(window.localStorage)) {
            if (key === `download-static-data-${localStorageKey}`) {
                const file = new Blob([value as string], { type: 'application/json' });
                const a = document.createElement('a'),
                    url = URL.createObjectURL(file);
                a.href = url;
                a.download = `${localStorageKey}.json`;
                document.body.appendChild(a);
                a.click();
                setTimeout(() => {
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                }, 0);
            }
        }

        // TODO: This is also temporary.
        if (key === 'switch-dataset') {
            const currentPath = window.location.pathname;
            const parameters = new URLSearchParams(window.location.search);
            parameters.set('dataset', parameters.get('dataset') === 'static' ? '' : 'static');
            window.location.href = `${window.location.origin}${currentPath}?${parameters.toString()}`;
            return;
        }

        switch (key) {
            case 'simulations':
                ModalHandler.showSimulationPanel();
                break;
            case 'settings':
                ModalHandler.showSettingsPanel();
                break;
        }
    };
    getMenuItems = (): ItemType[] => {
        // TODO: This is temporary code to be able to download static data captured in recording mode.
        // new URLSearchParams(window.location.search).get('record-data') === '1'
        const recordedDataItems = [
            { key: 'divider-2', type: 'divider' },
            {
                key: 'switch-dataset',
                label: `Use ${new URLSearchParams(window.location.search).get('dataset') === 'static' ? 'Normal' : 'Static'} Dataset`,
            },
            ...Object.entries(window.localStorage)
                .filter(([key, _val]) => key.startsWith('Static__'))
                .map(([key, _val]) => ({
                    key: `download-static-data-${key}`,
                    label: `Download ${key}`,
                })),
        ];

        return [
            { key: 'simulations', label: 'Simulations' },
            { key: 'settings', label: 'Settings' },
            { key: 'divider', type: 'divider' },
            {
                key: 'logout',
                itemIcon: <LogoutOutlined style={{ marginLeft: '1.5em' }} />,
                label: <a href={AppContext.configData.logoutUrl}>Logout</a>,
            },
            ...recordedDataItems,
        ];
    };
    render() {
        return (
            <PopoverMenu
                onMenuItemClick={this.handleMenuItemClick}
                menuItems={this.getMenuItems()}
                placement="rightTop">
                <MenuOutlined />
            </PopoverMenu>
        );
    }
}
